import React from 'react';
import { Button, Container, Row, Col, Card } from 'react-bootstrap';
import styles from '../../assets/styles/Narozeniny.module.scss';
import stylesHomePage from '../../assets/styles/HomePage.module.scss';
import BtnPhone from '../BtnPhone';
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faGift, faGlassCheers, faCalendarCheck, faPhone, faInfoCircle, faUtensils } from '@fortawesome/free-solid-svg-icons';

import Header from '../Header';
import Footer from '../Footer';

const infoCards = [
    {
        title: "Plánování",
        getContent: () => (
            <>
                Nechte nás vytvořit <b>oslavu, na kterou se nezapomíná</b>, pro vaše dítě a jeho přátele.
                <br />
                <br />
                Rezervaci termínu prosím provádějte s dostatečným předstihem.
            </>
        ),
        icon: faCalendarCheck,
        className: styles.planovani
    },
    {
        title: "Catering",
        getContent: () => (
            <>
                Užijte si oslavu bez starostí s jídlem - <b>poskytneme vše kromě dortu</b>, který můžete přinést s sebou pro slavnostní okamžiky.
                <br />Ke standardní nabídce můžete přidat <b>lahůdkové mísy a různé pochutiny</b>.
                <br />Jako pozornost přijměte jednu lahev dětského šampaňského.
            </>
        ),
        icon: faUtensils,
        className: styles.catering
    },
    {
        title: "Možnosti",
        getContent: () => (
            <>
                Vaši oslavu lze uspořádat v časech 10:00&nbsp;-&nbsp;14:00 nebo 15:00&nbsp;-&nbsp;19:00.
                <br />
                Rezervaci je možné zrušit nejpozději 14 dní předem.
                <br />
                V případě nepředvídatelných změn lze oslavu přesunout.
            </>),
        icon: faGlassCheers,
        className: styles.flexibilita
    },
    {
        title: "Kompletní balíček",
        getContent: () => (
            <>
                Za cenu <b>300 Kč za malého hosta</b> získáte nejen vstupné na celý den,
                ale i výběr nealkoholického nápoje a krásně ozdobený stůl s dětským šampaňským.
            </>
        ),
        icon: faGift,
        className: styles.balicek
    },
    {
        title: "Exkluzivní prostory",
        getContent: () => (
            <>
                Oslava proběhne ve speciálním prostoru naší herny, který je částečně oddělený,
                avšak prostor zůstává otevřený pro veřejnost.
            </>
        ),
        icon: faInfoCircle,
        className: styles.prostory
    },
    {
        title: "Objednání",
        getContent: () => (
            <>
                <p>Zavolejte nám a společně projdeme detaily a podmínky oslavy.</p>
                <p><b>Závazek potvrdíte zálohou 1&nbsp;000&nbsp;Kč</b>.</p>
                <BtnPhone />
            </>
        ),
        icon: faPhone,
        className: styles.objednavka
    }
    // Zde by měly být další čtyři položky pole...
];

const Narozeniny = () => {
    return (
        <div>
            <Header headerAbsolute={true} />
            <Container fluid className={`g-0`}>

                <div className={styles.heroImage}>
                    <div className={stylesHomePage.heroText}>
                        <h1>Narozeniny</h1>
                        <p className='lead'>Slavte s námi v Herně Mauglí!</p>
                    </div>
                </div>
            </Container>
            <Container fluid className='p-4'>
                <Row className='justify-content-center'>
                    <Col xs="12" lg="8" className='d-flex flex-column justify-content-center text-center'>
                        <h2>Chystáte oslavu, na kterou se nezapomíná?</h2>
                        <p className='lead'>
                         Připravíme vašim dětem a jejich kamarádům nezapomenutelný den plný her a zábavy. Nabízíme vše od plánování, přes catering až po speciálně vyzdobené prostory. 
                         <br />
                         Přijďte oslavit s námi a užijte si čas, zatímco my se postaráme o všechno ostatní. Rezervujte svůj termín včas!</p>
                    </Col>
                </Row>
            </Container>

            <Container className={`${styles.birthdayPage} pb-5`}>
                <Row>
                    {infoCards.map((card, index) => {
                        // Tady je definice proměnné 'colored', používám '===' pro porovnání
                        const colored = index % 2 === 0 ? styles.colored : ""; // Předpokládám, že máte definovanou třídu 'colored' v souboru SCSS

                        return (
                            <Col sm lg={4} md={6} key={index} className='g-0'>
                                <Card className={`${card.className} h-100 rounded-0 ${colored}`}>
                                    <Card.Body className='p-5'>
                                        <Card.Title>
                                            <FontAwesomeIcon icon={card.icon} /> {card.title}
                                        </Card.Title>
                                        <Card.Text>
                                            {card.getContent()}
                                        </Card.Text>
                                    </Card.Body>
                                </Card>
                            </Col>
                        );
                    })}
                </Row>
            </Container>
            <Footer/>
        </div >
    );
};

export default Narozeniny;
